const VARIABLES = {
  LESSONS: {
    TYPE: {
      LESSON: 0,
      EXPRESSIONLEARNER: 1,
      CHATBOT: 2,
      DAILY: 3,
      OVERALL: 4,
      GRAMMAROVERALL: 5,
      GRAMMAR: 6,
      EXPRESSIONEXERCISE: 9,
      EXERCISE: 10,
      PRONUNCIATION: 11,
      CHATBOT_GPT: 12,
      DOTS: 99,
      BUNDLE: 100
    },
    REVERSE_TYPE: {
      0: 'LESSON',
      1: 'EXPRESSIONLEARNER',
      2: 'CHATBOT',
      3: 'DAILY',
      4: 'OVERALL',
      5: 'GRAMMAROVERALL',
      6: 'GRAMMAR',
      9: 'EXPRESSIONEXERCISE',
      10: 'EXERCISE',
      11: 'PRONUNCIATION',
      12: 'CHATBOT_GPT',
      99: 'DOTS',
      100: 'BUNDLE'
    },
    EXPRESSIONS_LENGTH_IN_MIN: 0.5
  },
  ASSIGNMENT: {
    STATUS: {
      CLOSED: 0,
      OPENED: 1
    }
  }
};

export default VARIABLES;



// WEBPACK FOOTER //
// ./src/components/shared/variables.js